// Lote 118 (Robson, 24/10/2026) — etiqueta colorida dos AUTOS de um processo (Principal, Exec. provisória, Incidente…).
// Um mesmo número CNJ pode ter vários autos monitorados ao mesmo tempo (ex.: o principal no tribunal e a execução
// provisória na 1ª instância). A cor identifica de relance a qual deles a tela se refere.
export const AUTOS_META = {
  principal:       { label: "Principal",              cls: "bg-stone-200 text-stone-700 border-stone-300",     dot: "bg-stone-500", faixa: "bg-stone-800 text-white", borda: "border-stone-700" },
  exec_provisoria: { label: "Exec. provisória",       cls: "bg-violet-100 text-violet-800 border-violet-300",  dot: "bg-violet-500", faixa: "bg-violet-700 text-white", borda: "border-violet-600" },
  cumprimento:     { label: "Cumprimento de sentença", cls: "bg-teal-100 text-teal-800 border-teal-300",       dot: "bg-teal-500", faixa: "bg-teal-700 text-white", borda: "border-teal-600" },
  incidente:       { label: "Incidente",              cls: "bg-orange-100 text-orange-800 border-orange-300",  dot: "bg-orange-500", faixa: "bg-orange-600 text-white", borda: "border-orange-500" },
  embargos:        { label: "Embargos/Recurso",       cls: "bg-sky-100 text-sky-800 border-sky-300",           dot: "bg-sky-500", faixa: "bg-sky-700 text-white", borda: "border-sky-600" },
  outro:           { label: "Outros autos",           cls: "bg-rose-100 text-rose-800 border-rose-300",        dot: "bg-rose-500", faixa: "bg-rose-700 text-white", borda: "border-rose-600" },
};
export const AUTOS_ORDEM = ["principal", "exec_provisoria", "cumprimento", "incidente", "embargos", "outro"];

export const autosMeta = (k) => AUTOS_META[k] || AUTOS_META.principal;
export const autosLabel = (k, nome) => (k === "outro" && nome ? nome : autosMeta(k).label);

export default function AutosTag({ autos = "principal", nome = null, className = "", testid }) {
  const m = autosMeta(autos);
  return (
    <span
      data-testid={testid || `autos-tag-${autos}`}
      className={`inline-flex items-center px-1.5 py-0.5 rounded border text-[10px] font-bold uppercase tracking-wide max-w-full ${m.cls} ${className}`}
    >
      <span className="truncate">{autosLabel(autos, nome)}</span>
    </span>
  );
}
